import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { brand, resolveBrand } from './lib/brand';
import './i18n';
import { applyTheme, detectInitialTheme } from './theme';
import { installDiagnostics } from './lib/diagnostics';
import './styles/global.css';

installDiagnostics();

// Build marker — confirm in the browser console which deploy actually loaded.
// eslint-disable-next-line no-console
console.log(`[LS webapp] version ${__APP_VERSION__} · build ${__BUILD_ID__}`);

// 套用持久化主題偏好(spec 16 §6.1)。render 前執行,避免 system→手動 的閃爍。
applyTheme(detectInitialTheme());

// Kinio 公版:render 前先依 domain 解析 brand 生態(08 §2.1.5)——bootstrap
// 決定 client 憑證,必須先於任何 login/refresh。未綁定 domain → 未啟用頁。
void resolveBrand().then(() => {
  const root = createRoot(document.getElementById('root')!);
  if (brand.isBrandHost && !brand.provisioned) {
    root.render(
      <StrictMode>
        <main style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', textAlign: 'center', padding: 24 }}>
          <div>
            <h1 style={{ marginBottom: 8 }}>Kinio</h1>
            <p>此網域尚未啟用任何品牌生態。/ This domain is not provisioned for any brand.</p>
            <p style={{ opacity: 0.7 }}>若你是品牌客戶,請聯絡平台完成網域綁定。</p>
          </div>
        </main>
      </StrictMode>
    );
    return;
  }
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
